import { Row, Col } from "antd";
import { useAuthContext } from "@/components/auth/AuthProvider";
import ReceiveMessage from "@/components/workshop/message/ReceiveMessage";
import TypeChart from "./TypeChart";
import DepartmentChart from "./DepartmentChart";
import MonthChart from "./MonthChart";
import AdministrativeChart from "./AdministrativeChart";
import AccumulatorMonthChart from "./AccumulatorMonthChart";
import styles from "./index.module.less";

function MessageStatistic() {
  const auth = useAuthContext();
  return (
    <div className={styles.messStatistic}>
      <Row gutter={16}>
        <Col span={12}>
          <TypeChart token={auth?.token} />
        </Col>
        <Col span={12}>
          <DepartmentChart token={auth?.token} />
        </Col>
        <Col span={12}>
          <MonthChart token={auth?.token} />
        </Col>
        <Col span={12}>
          <AdministrativeChart token={auth?.token} />
        </Col>
        <Col span={24}>
          <AccumulatorMonthChart token={auth?.token} />
        </Col>
        <Col span={24}>
          <ReceiveMessage />
        </Col>
      </Row>
    </div>
  );
}

export default MessageStatistic;
